/*
 * サブシステム名：マスタ管理
 * 機能名：営業所マスタ登録
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdIconButtonWithTooltip = () => import('../../components/DdIconButtonWithTooltip.vue')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstEigyoshoEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRadioButton,
    DdSubHeader,
    DdSwitch,
    DdTextBox
  },
  data: () => ({
    id: 0,
    copyMode: false,
    rec: {},
    invalidMessages: {},
    // **************
    seikyushoDispUseFlgDisp: true,
    eigyoshoKbnDisp: '01',
    eigyoshoKbnHacchusakiDisp: false,
    ginkoKoza: [],
    // **************
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersJishaginkokozaList: header.mstJishaGinkoKouzaHeaders,
    headers: [
      { width: '2%', value: 'actions' },
      { text: '金融機関コード', value: 'kinyuKikanCd' },
      { text: '金融機関名', value: 'kinyuKikanNm' },
      { text: '金融機関支店コード', value: 'kinyuKikanShitenCd' },
      { text: '金融機関支店名', value: 'kinyuKikanShitenNm' },
      { text: '口座種別', value: 'kozaSbtNm' },
      { text: '口座番号', value: 'kozaNo' },
      { text: '口座名義', value: 'kozaMeigiNm' }
    ],
    modeOfEdit: 2,
    modeKengen: 2,
    items: [
      {
        link: '#eigyoshokihonjoho',
        text: '基本情報',
        icon: 'mdi-database'
      },
      {
        link: '#seikyushojoho',
        text: '請求書情報',
        icon: 'mdi-file-document-edit'
      },
      {
        link: '#tekiyoKikan',
        text: '適用期間',
        icon: 'mdi-av-timer'
      }
    ],
    showCopyDialog: false
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jishaginkokozaList: 'DDMasters/mstJishaGinkoKoza',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      sysFlg: 'users/sysFlg'
    }),
    filteredTorihikisakiList () {
      // 発注先のみを表示
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.hacchusakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredJishaginkokozaList () {
      return this.jishaginkokozaList.map((elem) => {
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kinyuKikanCd > elem2.kinyuKikanCd) { return 1 }
        if (elem1.kinyuKikanCd < elem2.kinyuKikanCd) { return -1 }
        if (elem1.kinyuKikanShitenCd > elem2.kinyuKikanShitenCd) { return 1 }
        if (elem1.kinyuKikanShitenCd < elem2.kinyuKikanShitenCd) { return -1 }
        return 0
      })
    },
    filteredChiikiSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI001')
    },
    filteredChikuSbt () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI002')
    },
    filteredUnyuKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF063')
    },
    filteredEigyoshoKbn () {
      const listData = this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN002' && elem.code.trim() !== '00'
      }).map(function (elem) {
        return elem
      })
      return listData
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2) && this.sysFlg) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && this.eigyoshoLockFlg) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2 && this.eigyoshoLockFlg && this.sysFlg) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
    console.log('mounted')
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        // **************
        eigyoshoKbnDisp: this.eigyoshoKbnDisp,
        seikyushoDispUseFlgDisp: this.seikyushoDispUseFlgDisp,
        eigyoshoKbnHacchusakiDisp: this.eigyoshoKbnHacchusakiDisp,
        ginkoKoza: this.ginkoKoza
        // **************
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      console.log('fetchData')
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/MstEigyosho/find?id=${this.id}`)
          .then((data) => {
            this.rec = data.payload
            console.log('fetchData', this.rec)
            // no.33 check
            delete this.rec.tekiyoStartYmd
            delete this.rec.tekiyoEndYmd

            this.chiikiSbt = this.chiikiSbt ? this.chiikiSbt : null
            this.chikuSbt = this.chikuSbt ? this.chikuSbt : null
            this.unyuKbn = this.unyuKbn ? this.unyuKbn : null
            // **************
            this.eigyoshoKbnDisp = this.rec.eigyoshoKbn
            this.seikyushoDispUseFlgDisp = this.rec.seikyushoDispUseFlg
            if (this.rec.eigyoshoKbn === '03') {
              this.eigyoshoKbnHacchusakiDisp = true
            } else {
              this.eigyoshoKbnHacchusakiDisp = false
            }
            // 自社銀行口座の設定
            this.ginkoKoza = []
            this.setGinkoKoza(this.rec.jishaGinkoKozaId1)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId2)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId3)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId4)
            this.setGinkoKoza(this.rec.jishaGinkoKozaId5)
            // **************
            resolve()
          })
      })
    },
    setGinkoKoza: function (kozaId) {
      console.log('setGinkoKoza', kozaId)
      if (kozaId !== null &&
          kozaId.trim !== '') {
        const kozaArr = this.jishaginkokozaList.filter(item => item.id === kozaId)
        // 口座種別名を取得
        const kbnArr = this.kubunList.filter(item => item.kbnShuruiCd === 'SFF070' && item.code.trim() === kozaArr[0].kozaSbt)
        console.log('kozaSbt', kbnArr[0].codeNm)
        kozaArr[0].kozaSbtNm = kbnArr[0].codeNm
        // 最終行に追加
        this.ginkoKoza.push(kozaArr[0])
      }
    },
    writeBackGinkoKoza: function () {
      const self = this
      self.rec.jishaGinkoKozaId1 = null
      self.rec.jishaGinkoKozaId2 = null
      self.rec.jishaGinkoKozaId3 = null
      self.rec.jishaGinkoKozaId4 = null
      self.rec.jishaGinkoKozaId5 = null
      self.ginkoKoza.forEach(function (elem, index) {
        if (index === 0) { self.rec.jishaGinkoKozaId1 = elem.id }
        if (index === 1) { self.rec.jishaGinkoKozaId2 = elem.id }
        if (index === 2) { self.rec.jishaGinkoKozaId3 = elem.id }
        if (index === 3) { self.rec.jishaGinkoKozaId4 = elem.id }
        if (index === 4) { self.rec.jishaGinkoKozaId5 = elem.id }
      })
    },
    initialize () {
      const option = {
        loadMasters: ['msttorihikisaki', 'mstjishaginkokoza', 'msyskubun', 'mstshubetsu'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            // 初期値の設定
            this.rec = {
              seikyushoDispUseFlg: true,
              eigyoshoKbn: '01',
              hyojiOrder: 9999,
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01',
              seikyushoKaishaNm: '',
              seikyushoYubinNo: '',
              seikyushoJusho1: '',
              seikyushoJusho2: '',
              seikyushoJusho3: '',
              seikyushoTelNo: '',
              seikyushoFaxNo: '',
              chiikiSbt: null,
              chikuSbt: null,
              unyuKbn: null,
              hacchusakiCd: '',
              jishaGinkoKozaNm: ''
            }
            // **************
            this.eigyoshoKbnDisp = '01'
            this.eigyoshoKbnHacchusakiDisp = false
            this.seikyushoDispUseFlgDisp = true
            this.ginkoKoza = []
            // **************

            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', this)
            // ユーザ保存項目の復元
            if (Object.keys(c).length !== 0) {
              this.rec.eigyoshoKbn = c.eigyoshoKbn
              var seikyushoDispUseFlgBool = c.seikyushoDispUseFlg === 'true'
              this.rec.seikyushoDispUseFlg = seikyushoDispUseFlgBool
              // **************
              this.eigyoshoKbnDisp = c.eigyoshoKbnDisp
              var eigyoshoKbnHacchusakiDispBool = c.eigyoshoKbnHacchusakiDisp === 'true'
              this.eigyoshoKbnHacchusakiDisp = eigyoshoKbnHacchusakiDispBool
              var seikyushoDispUseFlgDispBool = c.seikyushoDispUseFlgDisp === 'true'
              this.seikyushoDispUseFlgDisp = seikyushoDispUseFlgDispBool
              // **************
            }
            console.log('★savedInputRestorePromise', this)
            resolve()
          })
        },
        existsIdMethod: () => {
          console.log('existsIdMethod')
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    /*
    eigyoshoKbnHacchusakiChange: function () {
      console.log('eigyoshoKbnHacchusakiChange')
      if (this.eigyoshoKbnHacchusakiDisp === false) {
        // 「発注先営業所を登録する」OFF時
        // 営業所区分を初期値に戻す
        this.eigyoshoKbnDisp = '01'
        // 発注先をクリア
        this.$set(this.rec, 'hacchusakiCd', '')
      }
    },
    */
    // 一度空文字を入れた後に選択すると、入力値が反映されないことがあるため強制的にセットする
    inputHacchusakiCd: function (param) {
      if (!this.eigyoshoKbnHacchusakiDisp) { return }
      this.$set(this.rec, 'hacchusakiCd', param)
    },
    copySeikyusho: function () {
      console.log('copySeikyusho', this.rec)
      this.rec.seikyushoKaishaNm = this.rec.eigyoshoNm
      this.rec.seikyushoYubinNo = this.rec.yubinNo
      this.rec.seikyushoJusho1 = this.rec.jusho1
      this.rec.seikyushoJusho2 = this.rec.jusho2
      this.rec.seikyushoJusho3 = this.rec.jusho3
      this.rec.seikyushoTelNo = this.rec.telNo
      this.rec.seikyushoFaxNo = this.rec.faxNo
    },
    deleteKozaJoho: function (item) {
      console.log('deleteKozaJoho', item)
      const index = this.ginkoKoza.indexOf(item)
      this.ginkoKoza.splice(index, 1)
    },
    addKozaJoho: function () {
      console.log('addKozaJoho', this.rec.jishaGinkoKozaNm)
      if (this.rec.jishaGinkoKozaNm !== undefined &&
          this.rec.jishaGinkoKozaNm !== null &&
          this.rec.jishaGinkoKozaNm.trim !== '') {
        if (this.ginkoKoza.length >= 5) {
          // todo:アラート不要か？
          // alert('3行までです')
        } else {
          // 重複チェック
          // const kozaArr = this.ginkoKoza.filter(item => item.id === this.rec.jishaGinkoKozaNm)
          // if (kozaArr.length !== 0) {
          //   // todo:アラート不要か？
          //   // alert('設定済の口座です')
          //   return
          // }
          this.setGinkoKoza(this.rec.jishaGinkoKozaNm)
          this.rec.jishaGinkoKozaNm = ''
        }
      }
    },
    upKozaJoho: function (item) {
      console.log('upKozaJoho', item)
      const index = this.ginkoKoza.indexOf(item)
      if (index > 0) {
        const cloneArray = this.replaceArrayElements(this.ginkoKoza, index, index - 1)
        this.ginkoKoza = cloneArray
      }
    },
    downKozaJoho: function (item) {
      console.log('downKozaJoho', item)
      const index = this.ginkoKoza.indexOf(item)
      if (index < this.ginkoKoza.length - 1) {
        const cloneArray = this.replaceArrayElements(this.ginkoKoza, index, index + 1)
        this.ginkoKoza = cloneArray
      }
    },
    replaceArrayElements: function (array, targetId, sourceId) {
      const cloneArray = [...array];
      [cloneArray[targetId], cloneArray[sourceId]] = [array[sourceId], array[targetId]]
      return cloneArray
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            console.log('■restoreInputsPromise', data())
            self.rec = data().rec
            // **************
            self.eigyoshoKbnDisp = data().eigyoshoKbnDisp
            self.seikyushoDispUseFlgDisp = data().seikyushoDispUseFlgDisp
            self.eigyoshoKbnHacchusakiDisp = data().eigyoshoKbnHacchusakiDisp
            self.ginkoKoza = data().ginkoKoza
            // **************
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstEigyosho/Delete?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this

      // **************
      if (this.eigyoshoKbnHacchusakiDisp) {
        self.rec.eigyoshoKbn = '03'
      } else {
        self.rec.eigyoshoKbn = this.eigyoshoKbnDisp
      }
      self.rec.seikyushoDispUseFlg = this.seikyushoDispUseFlgDisp
      // 口座情報の書戻し
      this.writeBackGinkoKoza()
      // **************

      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            self.copyMode = false
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.rec.eigyoshoCd !== this.rec.eigyoshoCd
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {
            eigyoshoKbn: self.rec.eigyoshoKbn,
            seikyushoDispUseFlg: self.rec.seikyushoDispUseFlg,
            // **************
            eigyoshoKbnDisp: self.eigyoshoKbnDisp,
            eigyoshoKbnHacchusakiDisp: self.eigyoshoKbnHacchusakiDisp,
            seikyushoDispUseFlgDisp: self.seikyushoDispUseFlgDisp
            // **************
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      // 発注先営業所出ない場合は発注先コードを初期化する
      if (this.eigyoshoKbnDisp !== '03') {
        this.rec.hacchusakiCd = null
      }
      if (this.id === 0) {
        console.log('Create', this.rec)
        f = this.HttpClient.post('/api/v1/MstEigyosho/Create', this.rec)
      } else {
        console.log('Update', this.rec)
        f = this.HttpClient.put(`/api/v1/MstEigyosho/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      console.log('validate start', this.cloneData)
      // 適用年月日の大小チェック
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    deleteValidate: function () {
      if (this.cloneData.rec.eigyoshoCd !== this.rec.eigyoshoCd) {
        this.$refs.eigyoshoCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['営業所コード']))
        this.setInvalidSummaryMessage('COME0015')
        this.rec.eigyoshoCd = this.cloneData.rec.eigyoshoCd
        return false
      }
      return true
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
          self.copyMode = true
        }
      }
      this.copyInputs(opt)
    }
  }
}
